module.exports = __webpack_public_path__ + "static/media/livraison.157c7158.png";